module.exports = __webpack_public_path__ + "img/pay-sdk-transaction-pending.fbdf8e63.png";